import removeCookie from "./removeCookie";
export default function removeCookies(cookies) {
    cookies.map(function (cookie) {
        if (typeof cookie === "string")
            removeCookie(cookie);
        else
            removeCookie(cookie.name, cookie.domain);
    });
}
